module.exports = __webpack_public_path__ + "/login_ui/img/pf-edf5258c9fc9710c6ee86a3695ef1a3a.svg";